import { useNuxtApp } from '#app'
import CheckedIcon from '~/assets/images/icons/icon-checked-green.svg'
import ClearIcon from '~/assets/images/icons/icon-clear.svg'
import WarningIcon from '~/assets/images/icons/icon-warning.svg'

type position = 'top' | 'center' | 'bottom'
type ToastType = 'success' | 'error' | 'warning'

export function toastPopup(options: {
  icon?: string
  title: string
  description?: string
  position?: position
  customContainerClass?: string
  type: ToastType
  isMobile?: boolean
}): void {
  const { $notify } = useNuxtApp()

  if (!options.icon) {
    switch (options.type) {
      case 'success':
        options.icon = CheckedIcon
        break
      case 'error':
        options.icon = ClearIcon
        break
      case 'warning':
        options.icon = WarningIcon
        break
      default:
        break
    }
  }

  $notify({
    toast: true,
    position: options.position ?? 'top',
    html: `
          <div class="d-flex align-items-center">
            ${options?.icon ? `<img src="${options?.icon}" class="icon" />` : ''}
            <div>
              <div class="title">${options.title}</div>
              <div class="desc">${options?.description ?? ''}</div>
            </div>
          </div>
          `,
    timer: 3000,
    showCloseButton: false,
    customClass: {
      container:
        options.customContainerClass ??
        `notify-top ${options.isMobile ? 'mobile' : 'desktop'} warning ${options.type || 'success'}`
    }
  })
}
